/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Soft_Skills_Too_ManyInputs */

const en_validation_soft_skills_too_many = /** @type {(inputs: Validation_Soft_Skills_Too_ManyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select at most 5 soft skills.`)
};

const de_validation_soft_skills_too_many = /** @type {(inputs: Validation_Soft_Skills_Too_ManyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Höchstens 5 Soft Skills auswählen.`)
};

/**
* | output |
* | --- |
* | "Please select at most 5 soft skills." |
*
* @param {Validation_Soft_Skills_Too_ManyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const validation_soft_skills_too_many = /** @type {((inputs?: Validation_Soft_Skills_Too_ManyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Soft_Skills_Too_ManyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_validation_soft_skills_too_many(inputs)
	return en_validation_soft_skills_too_many(inputs)
});